import * as actions from '../../redux/actions';
import HeroSection from '../../common/HeroSection/HeroSection';
import React, { Component, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import officeBanner from '../../assets/andimar/favoriteDestinations/andimar-offices-banner.jpg';
import { AndimarTitle } from '../../common/Title/AndimarTitle';
import KuposTabs from '../../../common/KuposTabs';
import CommonService from '../../../../services/commonService';
import getSlides from '../../functions/getSlides/getSlides';
import address3 from '../../assets/andimar/favoriteDestinations/address3.jpg';
import address4 from '../../assets/andimar/favoriteDestinations/address4.jpg';
import address5 from '../../assets/andimar/favoriteDestinations/address5.jpg';
import address6 from '../../assets/andimar/favoriteDestinations/address6.jpg';
import address7 from '../../assets/andimar/favoriteDestinations/address7.jpg';
import address8 from '../../assets/andimar/favoriteDestinations/address8.jpg';
import address9 from '../../assets/andimar/favoriteDestinations/address9.jpg';
import address10 from '../../assets/andimar/favoriteDestinations/address10.jpg';
import address11 from '../../assets/andimar/favoriteDestinations/address11.jpg';
import address12 from '../../assets/andimar/favoriteDestinations/address12.jpg';
import address14 from '../../assets/andimar/favoriteDestinations/AndimarWebsite-Offices-Calama.jpg';
import getIcons from '../../functions/getIcons/getIcons';
import MultiSlider3 from '../../common/MultiSlider/MultiSlider3';
import KuposHelmet from '../../../common/KuposHelmet';

const address13 = '/assets/andimar/AndimarWebsite-Offices-ZonaSur-Molina.png';

const stepOneItem = [
  {
    title: 'Terminal Copiapó Andimar',
    image: address3,
    address: ' Colipí Nº114, Esquina Ramón Freire.',
    phone: ' (+56 52) 221 98 79',
    timing: ' Horario: 5:30 Hrs. - 23:30 Hrs.',
    mapLink:
      'https://www.google.com/maps/place/27%C2%B02211.2%22S+70%C2%B02003.1%22W/@-27.3697731,-70.3429183,15z/data=!3m1!4b1!4m5!3m4!1s0x0:0xe1c7b3b40d180d5f!8m2!3d-27.3697734!4d-70.334185',
  },

  {
    title: 'Terminal Calama',
    image: address14,
    address: 'Granaderos 2963, Of. 16.',
    // phone: ' (+56 52) 221 98 79',
    // timing: ' Horario: 5:30 Hrs. - 23:30 Hrs.',
    mapLink:
      'https://www.google.com/maps/place/27%C2%B02211.2%22S+70%C2%B02003.1%22W/@-27.3697731,-70.3429183,15z/data=!3m1!4b1!4m5!3m4!1s0x0:0xe1c7b3b40d180d5f!8m2!3d-27.3697734!4d-70.334185',
  },

  {
    title: 'Terminal Terrapuerto',
    image: '/assets/andimar/AndimarWebsite-Offices-ZonaNorte-TerminalTerrapuerto.png',
    address: 'Ruta Cinco Norte (altura Km 804), Of. 7-8,16-17, 24-27.',
    // phone: ' (+56 55) 260 14 89', Phone N/A
    timing: 'Horario: 8:00 Hrs. - 23:00 Hrs.',
    mapLink:
      // 'https://www.google.com/maps/place/Terminal+Los+H%C3%A9roes/@-33.4436311,-70.6711205,14.63z/data=!4m5!3m4!1s0x9662c5a86150cb3d:0xa7a1780f2d3bf7d1!8m2!3d-33.4447519!4d-70.6584987',
      'https://www.google.com/maps/place/Terminal+Terrapuerto/@-27.3778858,-70.3367087,17z/data=!3m1!4b1!4m5!3m4!1s0x96980477eb3c6121:0xe1ff09a96fd77fc4!8m2!3d-27.3778858!4d-70.3367087?shorturl=1',
  },
  {
    title: 'Terminal Vallenar',
    image: address5,
    address: ' Arturo Prat Nº137 Of. 09',
    phone: ' (+56 51) 261 36 17',
    timing: 'Horario: 7:15 Hrs. - 23:50 Hrs.',
    mapLink:
      'https://www.google.com/maps/place/28%C2%B03432.3%22S+70%C2%B04525.5%22W/@-28.5756301,-70.7658226,15z/data=!3m1!4b1!4m5!3m4!1s0x0:0x1e839b1a3bbbc4db!8m2!3d-28.5756304!4d-70.7570893',
  },
  {
    title: 'Terminal La Serena',
    image: address4,
    address: ' Amunategui Nº107, B-3',
    phone: ' (+56 51) 236 03 83',
    timing: 'Horario: Todo el día.',
    mapLink:
      'https://www.google.com/maps/place/Amun%C3%A1tegui+107,+La+Serena,+Coquimbo,+Chile/@-29.9105751,-71.2586288,17z/data=!3m1!4b1!4m5!3m4!1s0x9691ca6e95ab142d:0x40209dc6c6d84bdf!8m2!3d-29.9105751!4d-71.2564401',
  },
  {
    title: 'Terminal Ovalle',
    image: address11,
    address: ' Aristía Pte. N°849, of. N°2',
    phone: ' (+56 53) 262 04 27',
    timing: 'Horario: 9:00 Hrs. - 00:00 Hrs.',
    mapLink:
      'https://www.google.com/maps/place/30%C2%B03623.8%22S+71%C2%B01141.0%22W/@-30.6065967,-71.2034487,15z/data=!3m1!4b1!4m5!3m4!1s0x0:0x59c1672450e6c05c!8m2!3d-30.606597!4d-71.1947154',
  },
  {
    title: 'Terminal Antofagasta',
    image: address12,
    address: 'Pedro Aguirre Cerda 5750, of. 13-13B.',
    phone: ' (+56 55) 260 14 89',
    timing: 'Horario: 8:00 Hrs. - 22:00 Hrs.',
    mapLink:
      'https://www.google.com/maps/place/23%C2%B03703.0%22S+70%C2%B02319.4%22W/@-23.6175028,-70.3974625,15z/data=!3m1!4b1!4m5!3m4!1s0x0:0x1aaf6df62bbbb1c3!8m2!3d-23.617503!4d-70.3887292',
  },
];

const stepTwoItem = [
  {
    title: 'Terminal San Borja',
    image: '/assets/andimar/favoriteDestinations/AndimarWebsite-Offices-Santiago-SanBorja1.jpg',
    address: 'San Borja Nº184, of. 37, 49B, 65, 25,-26.',
    phone: '(+56 2) 276 48 902',
    timing: 'Horario: 5:30 Hrs. - 23:30 Hrs.',
    mapLink:
      'https://www.google.com/maps/place/33%C2%B02717.0%22S+70%C2%B04049.4%22W/@-33.4547219,-70.6825889,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xdc8ababde4770677!8m2!3d-33.4547219!4d-70.6804002',
  },
  {
    title: 'Terminal Santiago Sur',
    image: '/assets/andimar/favoriteDestinations/AndimarWebsite-Offices-Santiago-TerminalSur2.jpg',
    address: 'Avda. Lib. Bernardo O. Nº3850, Of. 20-21, 132, 147-148.',
    phone: '(+56 2) 2779 38 10',
    timing:
      'Horario: Lunes a viernes: 4:30 Hrs. – 23:00 Hrs. Sábados y domingos: 5:30 Hrs. - 23:00 Hrs.',
    mapLink:
      'https://www.google.com/maps/place/33%C2%B02710.7%22S+70%C2%B04109.9%22W/@-33.4529579,-70.6882666,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x441d4df2ef4c407f!8m2!3d-33.4529579!4d-70.6860779',
  },

  // {
  //   title: 'Terminal Los Héroes',
  //   image: '/assets/andimar/AndimarWebsite-Offices-Santiago-TerminalTerrapuerto.png',
  //   address: 'Ruta Cinco Norte (altura Km 804), Of. 7-8,16-17, 24-27.',
  //   timing: 'Horario: 8:00 Hrs. - 23:00 Hrs.',
  //   mapLink:
  //     'https://www.google.com/maps/place/Terminal+Los+H%C3%A9roes/@-33.4447579,-70.6672415,15z/data=!3m1!4b1!4m5!3m4!1s0x9662c5a86150cb3d:0xa7a1780f2d3bf7d1!8m2!3d-33.4447519!4d-70.6584987',
  // },
];

const stepThreeItem = [
  {
    title: 'Arica',
    image: address6,
    address: ' Diego Portales 948 - Of. 2.',
    phone: ' (+56 9) 3944 1891',
    mapLink:'https://www.google.com/maps/place/Terminal+Rodoviario+Arica/@-18.4726743,-70.3066004,17z/data=!4m9!1m2!2m1!1sterminal+rodovi%C3%A1rio+cerca+de+Arica!3m5!1s0x915aa9bb12a408ab:0x825014a99824dbee!8m2!3d-18.4727087!4d-70.3040741!15sCiN0ZXJtaW5hbCByb2RvdmnDoXJpbyBjZXJjYSBkZSBBcmljYZIBC2J1c19zdGF0aW9u'},
  {
    title: 'Iquique',
    image: address7,
    address: ' Patricio Lynch 50 - Of. 5.',
    phone: ' (+56 9) 4228 1876',
    mapLink:"https://www.google.com/maps/place/Terminal+Rodoviario+de+Iquique/@-20.2081952,-70.1543899,17z/data=!3m1!4b1!4m5!3m4!1s0x91521153ea03964d:0x4e0a372c24c36f87!8m2!3d-20.2082!4d-70.1504"
  },
  
];

const ThemeTenOffices = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

  const officeData = [
    {
      title: 'Arica',
      image: getIcons('Office1',operator),
      address: ' Diego Portales 948 - Of. 2.',
      phone: ' (+56 9) 3944 1891',
      mapLink:'https://www.google.com/maps/place/Terminal+Rodoviario+Arica/@-18.4726743,-70.3066004,17z/data=!4m9!1m2!2m1!1sterminal+rodovi%C3%A1rio+cerca+de+Arica!3m5!1s0x915aa9bb12a408ab:0x825014a99824dbee!8m2!3d-18.4727087!4d-70.3040741!15sCiN0ZXJtaW5hbCByb2RvdmnDoXJpbyBjZXJjYSBkZSBBcmljYZIBC2J1c19zdGF0aW9u'
    },
    {
      title: 'Iquique',
      image: getIcons('Office2',operator),
      address: ' Patricio Lynch 50 - Of. 5.',
      phone: ' (+56 9) 4228 1876',
      mapLink:"https://www.google.com/maps/place/Terminal+Rodoviario+de+Iquique/@-20.2081952,-70.1543899,17z/data=!3m1!4b1!4m5!3m4!1s0x91521153ea03964d:0x4e0a372c24c36f87!8m2!3d-20.2082!4d-70.1504"
    },
    
  ];

  const slides = [address3, address4, address4, address5];
  const initalState = {
    selectedTab: 1,
  };

  const [state, setState] = useState(initalState);

  const tabs = ['Zona norte', 'Santiago', 'Zona Sur'];

  const onTabChange = tab => {
    setState({ ...state, selectedTab: tab });
  };

  const destinationItems = state.selectedTab == 2 ? stepTwoItem : stepThreeItem;

  const destinationItemsStepTwoAndThree = stepTwoItem.map((item, key) => {
    return (
      <div className="montserrat" style={{ margin: 20, width: '245px' }}>
        <img src={item.image} style={{ maxHeight: 250 }} alt="" />
        <div
          style={{
            background: '#F3F7FF',
            padding: 20,
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
            minHeight: '318px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ minHeight: 140 }}>
            <div
              className="font10 text-bold"
              style={{
                display: 'flex',
                alignItems: 'baseline',
                marginBottom: 15,
                lineHeight: 1.3,
                color: 'black',
                fontWeight: 'bold',
              }}
            >
              {item.title}
            </div>

            <div
              className="font10"
              style={{ display: 'flex', alignItems: 'baseline', marginBottom: 15, lineHeight: 1.3 }}
            >
              <img
                src={getIcons('Destination', operator)}
                style={{ width: 15, marginRight: 5 }}
                alt=""
              />
              {item.address}
            </div>

            {item.phone ? (
              <div
                className="font10"
                style={{ display: 'flex', alignItems: 'baseline', marginBottom: 15 }}
              >
                <img
                  src={getIcons('TelephoneIcon', operator)}
                  style={{ width: 15, marginRight: 5 }}
                  alt=""
                />
                {item.phone}
              </div>
            ) : null}

            <div
              className="font10"
              style={{ display: 'flex', alignItems: 'baseline', marginBottom: 15, lineHeight: 1.3 }}
            >
              <img
                src={getIcons('ClockIcon', operator)}
                alt=""
                style={{ width: 15, marginRight: 5 }}
              />
              {item.timing}
            </div>
          </div>
          <div className="font11" style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={getIcons('BlueArrow', operator)}
              style={{ height: 10, width: 10, marginRight: 5 }}
              alt=""
            />
            <a
              href={item.mapLink}
              target="_blank"
              style={{ textDecoration: 'underline', color: operator && operator.theme_color2 }}
            >
              Ver mapa
            </a>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div>
      <KuposHelmet />
      <HeroSection
        heroImage={getIcons('OfficeBanner',operator)}
        height={'41vh'}
        title={'Oficinas'}
        description={'Home / Oficinas'}
        marginTop="-50px"
      />

      <div className="new-container">
        <AndimarTitle title={'OFICINAS'} />
        {/* <KuposTabs
          tabs={tabs}
          onTabChange={onTabChange}
          selectedTab={state.selectedTab}
          operator={operator}
        /> */}
        <div >
          {/* {state.selectedTab === 1 || state.selectedTab === 3 ? ( */}
            <div>
              <MultiSlider3
                // multiSlides={state.selectedTab == 1 ? stepOneItem : stepThreeItem}
                multiSlides={officeData}
                textCard={true}
                removeArrowOnDeviceType={[]}
                sanantonioArrowStyle
                operator={operator}
              />
            </div>
          {/* ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                marginTop: '20px',
              }}
            >
              {destinationItemsStepTwoAndThree}{' '}
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeTenOffices);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/ThemeTenPages/ThemeTenOffices.js